import {useEffect, useState} from 'react';
import useStyles from '../../styles/global-mui.js';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { Grid, TextField, Typography } from '@mui/material';
import { createPlayer } from '../../actions/players.js';
import { useDispatch } from 'react-redux';
import DsasButton from '../../v1/components/DsasButton/DsasButton.js';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
  
  function ConfirmationDialogRaw({onClose, open, discipline, teamId, provider, match}) {

    const initialData = {firstname : '', lastname : '', teams : [teamId], discipline : discipline, number : '', teamsSeason : [], provider}

    const [playerData, setPlayerData] = useState(initialData)

    const dispatch = useDispatch()

    const classes = useStyles();

      const handleClose = () => {
        onClose();
      };

    useEffect(() => {
      if(teamId)
        setPlayerData(s => ({...s, teams : [teamId]}))
    }, [teamId])
  
    const handleCancel = () => {
      onClose();
    };
  
    const handleOk = () => {
      // Sauvegarder le joueur
      if(!playerData.firstname.trim() || !playerData.lastname.trim())
        return

      // On valorise correctement teamsSeason
      let teamsSeason = [{team : teamId, startDate : new Date(match.dateTime).setHours(0, 0, 0, 0)}]

      dispatch(createPlayer({...playerData, teamsSeason}))

      setPlayerData(initialData)

      onClose();
    };
  
    const handleChange = (e) => {
      setPlayerData(s => ({...s, [e.target.name]: e.target.value}))
    };
  
    return (
      <Dialog
        onClose={handleClose}
        open={open}
        className={classes.customPopup}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(109, 110, 115, 0.6)', // <-- équivalent à #6D6E73 à 60%
          }
        }}>
         {/* Bouton de fermeture */}
              <Box
                sx={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  border: '2px solid var(--color-blue-secondary)', // Cercle fin
                  backgroundColor: 'var(--color-white)', // Fond blanc
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  zIndex: 1,
                  '&:hover': {
                    backgroundColor: 'var(--color-white)',
                  },
                }}
                onClick={handleClose}
              >
                <Box
                  component="span"
                  sx={{
                    fontSize: '14px',
                    fontWeight: 600,
                    lineHeight: 1,
                    color: 'var(--color-blue-secondary)',
                  }}
                >
                  ×
                </Box>
              </Box>

      <Box alignItems="center" textAlign={"center"} className='medium-padding'>
       <Typography variant='h2' className='popupTitle'>Créer un joueur</Typography>

        <Grid container spacing={2} className='medium-padding'>
                        <Grid item xs={12}>
                           <TextField
                                  name="lastname" 
                                  label="Nom" 
                                  fullWidth 
                                  className={classes.customInput}
                                  value={playerData.lastname}
                                  onChange={handleChange}
                              />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField 
                                name="firstname" 
                                label="Prénom" 
                                fullWidth 
                                className={classes.customInput}
                                value={playerData.firstname}
                                onChange={handleChange}
                            />
                        </Grid>
                      </Grid>
                      </Box>
               <Box className='large-separator'></Box>
               <Box className='centered-wrapper' sx={{
                 justifyContent: 'space-evenly',
               }}>
               <Box className='centered-wrapper'>
                 <DsasButton 
                  variant='secondary' 
                  label="Annuler" 
                  customCss={{margin:0}}
                  onClick={handleCancel}></DsasButton>
               </Box>

               <Box className='medium-vertical-separator'></Box>
               
               <Box className='centered-wrapper'>
                 <DsasButton 
                  variant='alternative' 
                  customCss={{width: 'fit-content',
                      paddingLeft: '30px',
                      paddingRight: '30px',
                      margin:0
                    }}
                  label="Valider" 
                  onClick={handleOk} 
                  disabled={!playerData.firstname || !playerData.lastname}></DsasButton>
               </Box>
              </Box>
             

        {/* <DialogContent dividers>
                <TextField
                sx={{marginBottom : 1}} 
                    name="lastname" 
                    variant="outlined"
                    label="Nom" 
                    fullWidth 
                    value={playerData.lastname}
                    onChange={handleChange}
                />

                <TextField 
                sx={{marginBottom : 1}} 
                    name="firstname" 
                    variant="outlined" 
                    label="Prénom" 
                    fullWidth 
                    value={playerData.firstname}
                    onChange={handleChange}
                />

        </DialogContent> */}
        {/* <DialogActions>
          <Button autoFocus onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleOk} disabled={!playerData.firstname || !playerData.lastname}>Ok</Button>
        </DialogActions> */}
      </Dialog>
    );
  }
  
  export default function CreatePlayerModal({teamId, discipline, provider, match}) {
    const [open, setOpen] = useState(false);
  
    const handleClickListItem = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    return (
      <Box className='centered-wrapper' sx={{ width: '100%', bgcolor: 'background.paper', textAlign : 'center' }}>
        <DsasButton onClick={handleClickListItem} variant="secondary" icon={faUserPlus} label='Créer un joueur'></DsasButton>
          <ConfirmationDialogRaw
            id="playerform"
            open={open}
            onClose={handleClose}
            teamId={teamId}
            discipline={discipline}
            provider={provider}
            match={match}
          />
      </Box>
    );
  }